import React from 'react';
import {NavLink} from 'react-router-dom';
// import HomeIcon from '../../assets/HomeIcon.svg';
// import AnalyticsIcon from "../../assets/AnalyticsIcon.svg";
// import ProposalsIcon from '../../assets/ProposalsIcon.svg';
import DistributorsIcon from '../../assets/DistributorsIcon.svg';
// import AddOnIcon from '../../assets/AddOnIcon.svg';
// import SettingsIcon from "../../assets/SettingsIcon.svg";
// import ServiceTypesIcon from "../../assets/ServiceTypesIcon.svg";
import UsersIcon from '../../assets/UsersIcon.svg';
import {useAuth} from '../../providers/AuthenticationProvider';

import './Navbar.css';

// const homeIcon = {
//   backgroundImage: `url(${HomeIcon})`,
//   backgroundRepeat: 'no-repeat',
//   backgroundPosition: '5% 50%',
// };

// const analyticsIcon = {
//   backgroundImage: `url(${AnalyticsIcon})`,
//   backgroundRepeat: "no-repeat",
//   backgroundPosition: "6% 50%",
// };

// const proposalsIcon = {
//   backgroundImage: `url(${ProposalsIcon})`,
//   backgroundRepeat: 'no-repeat',
//   backgroundPosition: '5% 50%',
// };

const distributorsIcon = {
  backgroundImage: `url(${DistributorsIcon})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: '7% 50%',
};

// const addOnIcon = {
//   backgroundImage: `url(${AddOnIcon})`,
//   backgroundRepeat: 'no-repeat',
//   backgroundPosition: '5% 50%',
// };

// const settingsIcon = {
//   backgroundImage: `url(${SettingsIcon})`,
//   backgroundRepeat: "no-repeat",
//   backgroundPosition: "5% 50%",
// };

// const serviceTypesIcon = {
//   backgroundImage: `url(${ServiceTypesIcon})`,
//   backgroundRepeat: "no-repeat",
//   backgroundPosition: "5% 50%",
// };

const usersIcon = {
  backgroundImage: `url(${UsersIcon})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: '5% 50%',
};

export const NavBar = () => {
  const {isSystemAdmin, isDistributorAdmin, isAccountExecutive, isPathianTech} = useAuth();
  return (
    <nav className="sideNav">
      {isSystemAdmin() ? (
        <div style={distributorsIcon} className="sideNavItem">
          <NavLink to="/distributors" end className={({ isActive }) =>
              isActive ? "selected" : ""
          }>
            Distributors
          </NavLink>
        </div>
      ) : null}
      {/*{isSystemAdmin() || isDistributorAdmin() ? (*/}
      {/*  <div style={addOnIcon} className="sideNavItem">*/}
      {/*    <NavLink to="/products" end className={({ isActive }) =>*/}
      {/*        isActive ? "selected" : ""*/}
      {/*    }>*/}
      {/*      Products*/}
      {/*    </NavLink>*/}
      {/*  </div>*/}
      {/*) : null}*/}
      {/* <div style={serviceTypesIcon} className="sideNavItem">
                <NavLink to="/service-types" end className={({ isActive }) =>
                isActive ? "selected" : ""
            }>
                Service Types
                </NavLink>
            </div> */}
      {/* <div style={settingsIcon} className="sideNavItem">
                <a href="/">Settings</a>
            </div> */}
      {/*{isSystemAdmin() || isDistributorAdmin() || isAccountExecutive() ? (*/}
      {/*  <div style={proposalsIcon} className="sideNavItem">*/}
      {/*    <NavLink to="/proposals" end className={({ isActive }) =>*/}
      {/*        isActive ? "selected" : ""*/}
      {/*    }>*/}
      {/*      Proposals*/}
      {/*    </NavLink>*/}
      {/*  </div>*/}
      {/*) : null}*/}
      {isSystemAdmin() || isDistributorAdmin() || isAccountExecutive() ? (
        <div style={usersIcon} className="sideNavItem">
          <NavLink to="/customers" end className={({ isActive }) =>
              isActive ? "selected" : ""
          }>
            Customers
          </NavLink>
        </div>
      ) : null}
      {isSystemAdmin() || isDistributorAdmin() ? (
        <div style={usersIcon} className="sideNavItem">
          <NavLink to="/users" end className={({ isActive }) =>
              isActive ? "selected" : ""
          }>
            Users
          </NavLink>
        </div>
      ) : null}
      <div style={usersIcon} className="sideNavItem">
        <NavLink to="/reports" end className={({ isActive }) =>
            isActive ? "selected" : ""
        }>
          Reports
        </NavLink>
      </div>
      <div style={usersIcon} className="sideNavItem">
        <NavLink to="/reports/create" end className={({ isActive }) =>
            isActive ? "selected" : ""
        }>
          Create New Report
        </NavLink>
      </div>
      {isSystemAdmin() ? (
        <>
          <div style={usersIcon} className="sideNavItem">
            <NavLink to="/reports/templates" end className={({ isActive }) =>
                isActive ? "selected" : ""
            }>
              Report Templates
            </NavLink>
          </div>
        </>
      ) : null}
      {isSystemAdmin() || isPathianTech() ? (
        <div style={usersIcon} className="sideNavItem">
          <NavLink to="/datainspector" end className={({ isActive }) =>
              isActive ? "selected" : ""
          }>
            Data Inspector
          </NavLink>
        </div>
      ) : null}

        <div style={usersIcon} className="sideNavItem">
          <NavLink to="/equipment" end className={({ isActive }) =>
              isActive ? "selected" : ""
          }>
            Equipment Benchmarking
          </NavLink>
        </div>
      {isSystemAdmin() || isPathianTech() ? (
        <div style={distributorsIcon} className="sideNavItem">
          <NavLink to="/sitehealth" end className={({ isActive }) =>
              isActive ? "selected" : ""
          }>
            Site Health
          </NavLink>
        </div>
      ) : null}
      {isSystemAdmin() || isPathianTech() ? (
        <div style={usersIcon} className="sideNavItem">
          <NavLink to="/data-maintenance" end className={({ isActive }) =>
              isActive ? "selected" : ""
          }>
            Data Maintenance
          </NavLink>
        </div>
      ) : null}
      {isSystemAdmin() || isPathianTech() ? (
      <div style={usersIcon} className="sideNavItem">
        <NavLink to="/utilityaccounts" end className={({ isActive }) =>
            isActive ? "selected" : ""
        }>
          Utility Accounts
        </NavLink>
      </div>
      ) : null}
      {isSystemAdmin() || isPathianTech() ? (
      <div style={usersIcon} className="sideNavItem">
        <NavLink to="/unit-conversions" end className={({ isActive }) =>
            isActive ? "selected" : ""
        }>
          Unit Conversions
        </NavLink>
      </div>
      ) : null}
      {/* {isSystemAdmin() ? (
          <div style={usersIcon} className="sideNavItem">
            <NavLink to="/component-tree" end className={({ isActive }) =>
                isActive ? "selected" : ""
            }>
              Component Tree
            </NavLink>
          </div>
      ) : null} */}
      {isSystemAdmin() || isPathianTech() ? (
          <div style={usersIcon} className="sideNavItem">
            <NavLink to="/component-manager" end className={({ isActive }) =>
                isActive ? "selected" : ""
            }>
              Components
            </NavLink>
          </div>
      ) : null}
      {isSystemAdmin() || isPathianTech() ? (
          <div style={usersIcon} className="sideNavItem">
            <NavLink to="/point-mapping" end className={({ isActive }) =>
                isActive ? "selected" : ""
            }>
              Point Mapping (Niagara)
            </NavLink>
          </div>
      ) : null}
      {isSystemAdmin() || isPathianTech() ? (
          <div style={usersIcon} className="sideNavItem">
            <NavLink to="/connector-mapping" end className={({ isActive }) =>
                isActive ? "selected" : ""
            }>
              Point Mapping (BACnet)
            </NavLink>
          </div>
      ) : null}
      {isSystemAdmin() || isPathianTech() ? (
          <div style={usersIcon} className="sideNavItem">
            <NavLink to="/connector-admin" end className={({ isActive }) =>
                isActive ? "selected" : ""
            }>
              Connector Admin
            </NavLink>
          </div>
      ) : null}
      {isSystemAdmin() || isPathianTech() ? (
          <div style={usersIcon} className="sideNavItem">
            <NavLink to="/reports/group" end className={({ isActive }) =>
                isActive ? "selected" : ""
            }>
              Group Report
            </NavLink>
          </div>
      ) : null}
      {isSystemAdmin() || isPathianTech() ? (
          <div style={usersIcon} className="sideNavItem">
            <NavLink to="/generic-points" end className={({ isActive }) =>
                isActive ? "selected" : ""
            }>
              Generic Points
            </NavLink>
          </div>
      ) : null}
      {isSystemAdmin() ? (
          <div style={usersIcon} className="sideNavItem">
            <NavLink to="/weather-stations" end className={({ isActive }) =>
              isActive ? "selected" : ""
            }>
              Weather Stations
            </NavLink>
          </div>
      ) : null}
      {isSystemAdmin() || isPathianTech() ? (
        <div style={usersIcon} className="sideNavItem">
          <NavLink to="/issue-options" end className={({ isActive }) =>
              isActive ? "selected" : ""
          }>
            Issue Options
          </NavLink>
        </div>
      ) : null}
      {isSystemAdmin() || isPathianTech() ? (
          <div style={usersIcon} className="sideNavItem">
            <NavLink to="/task-options" end className={({ isActive }) =>
                isActive ? "selected" : ""
            }>
              Task Options
            </NavLink>
          </div>
      ) : null}
    </nav>
  );
};
